import merge from 'lodash/merge';

import { push } from 'utils/routerRedux';

import { CREATE_TOAST, REMOVE_TOAST, CLEAR_ALL_TOASTS } from './constants';

// Legacy toast actions.
// Toast implementation has been moved to `/app/features/toaster/`, but this is still here to keep the new
// stack compatible with old components that still dispatch a redux toast action.
// these actions are then caugt by a saga in `/app/containers/App/sagas.js`, and redirected to the `ToastSagasAdapter`.
// keep reading there for more info.

const createBaseToast = (kind, message, settings) => {
  const defaults = { dismissable: true };
  const options = { ...defaults, ...settings };

  return {
    kind,
    message,
    options,
  };
};

export function createToast(kind, message, settings) {
  return {
    type: CREATE_TOAST,
    ...createBaseToast(kind, message, settings),
  };
}

export const createInfoToast = (message, settings) =>
  createToast('info', message, settings);
export const createSuccessToast = (message, settings) =>
  createToast('success', message, settings);
export const createWarningToast = (message, settings) =>
  createToast('warning', message, settings);
export const createErrorToast = (message, settings) =>
  createToast('error', message, settings);

export const pushWithToast = (location, kind, message, settings) => {
  const locationToast = {
    state: { toast: createBaseToast(kind, message, settings) },
  };

  if (typeof location === 'string') {
    const locationDescriptor = { pathname: location, ...locationToast };
    return push(locationDescriptor);
  }

  return push(merge(location, locationToast));
};

export const pushWithInfoToast = (location, message, settings) =>
  pushWithToast(location, 'info', message, settings);
export const pushWithSuccessToast = (location, message, settings) =>
  pushWithToast(location, 'success', message, settings);
export const pushWithWarningToast = (location, message, settings) =>
  pushWithToast(location, 'warning', message, settings);
export const pushWithErrorToast = (location, message, settings) =>
  pushWithToast(location, 'error', message, settings);

export function removeToast(id) {
  return {
    type: REMOVE_TOAST,
    id,
  };
}

export function clearToasts() {
  return {
    type: CLEAR_ALL_TOASTS,
  };
}

export function clearAllToasts() {
  return {
    type: CLEAR_ALL_TOASTS,
  };
}
